import { CategoricalBarChartCategoryAxisProps } from '../types/categorical-bar-chart.js';

/**
 * Category axis slot component.
 */
export const CategoryAxis = (props: CategoricalBarChartCategoryAxisProps) =>
  null;

CategoryAxis['displayName'] = 'CategoricalBarChart.CategoryAxis';
